import { AgGridReactProps } from '@ag-grid-community/react';
import { Box, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { LinkProps, Link as RouterLink } from 'react-router-dom';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

const Link = (RouterLink as unknown) as React.ComponentClass<LinkProps>;

interface IAllWalletsPinnedProps extends AgGridReactProps{
    data: any;
}

const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        height: '100%',
        color: theme?.app?.applicationColors.enumColors.white ||
            '#fff',
        textDecoration: 'inherit',
        padding: '0 .25rem 0 2rem',
        backgroundColor: theme?.app?.clientTheme.colors.primaryColorDark ||
            '#0A2240',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme?.app?.clientTheme.colors.primaryColorLight ||
                '#009BDF'
        }
    },
    title: {
        fontSize: '1.3rem',
        lineHeight: '1.5rem',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    },
    count: {
        backgroundColor: theme?.app?.clientTheme.colors.buttons.primaryHoverLight ||
            '#bec6d470',
        padding: '.75rem 1rem',
        fontSize: '1.25rem',
        lineHeight: '1.4rem',
        borderRadius: '10px',
        marginRight: '5px'
    }
}));

export function AllWalletsPinnedCellRenderer(props: IAllWalletsPinnedProps) {
    const { data } = props;

    const {
        root,
        title,
        count
    } = muiStyles(props);

    return (
        <Grid
            alignItems='center'
            className={`${root} firm-info-cell`}
            component={Link}
            container
            direction='row'
            id='clientAllWalletsRow'
            spacing={0}
            to='/accounts/history'
        >
            <Grid
                alignItems='flex-start'
                container
                direction='column'
                item
                justifyContent='flex-start'
                spacing={1}
                wrap='nowrap'
                xs={6}
            >
                <Box
                    className={title}
                    fontWeight='bold'
                >{data.title}
                </Box>
                <Box
                    className={title}
                    fontWeight='bold'
                >Transaction History
                </Box>
            </Grid>
            <Grid
                alignItems='flex-start'
                container
                item
                justifyContent='flex-end'
                spacing={0}
                xs={6}
            >
                <Box
                    className={count}
                    id='clientAllWalletsCount'
                >{data.count}
                </Box>
            </Grid>
        </Grid>
    );
}

export default (AllWalletsPinnedCellRenderer);